<template>
    <v-row justify="center">
        <v-dialog
            :value="dialog"
            max-width="290"
            persistent
        >
            <v-card>
                <v-card-title class="headline">
                  {{dialogTitle}}
                </v-card-title>

                <v-card-text>
                    {{dialogMessage}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                  <v-btn
                      v-if="dialogIsConfirm"
                      color="green darken-1"
                      text
                      @click="closeCancelDialog"
                  >
                    {{dialogCancelMessage}}
                  </v-btn>

                  <v-btn
                      color="green darken-1"
                      text
                      @click="closeOkDialog"
                  >
                    {{dialogOkMessage}}
                  </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      dialog: state => state.modal.isOpen,
      dialogIsConfirm: state => state.modal.isConfirm,
      dialogTitle: state => state.modal.title,
      dialogMessage: state => state.modal.message,
      dialogOkMessage: state => state.modal.ok,
      dialogCancelMessage: state => state.modal.cancel
    }),
  },
  methods: {
    closeOkDialog(){
      this.$store.dispatch('modal/resolve', true)
    },
    closeCancelDialog(){
      this.$store.dispatch('modal/reject', true)
    }
  }
}
</script>
